import React from "react";
import { SvgIcon } from "@mui/material";
function WebinarIcon(props) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <svg
        width="22"
        height="18"
        viewBox="0 0 22 18"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path d="M21 2H3C1.9 2 1 2.9 1 4V18C1 19.1 1.9 20 3 20H21C22.1 20 23 19.1 23 18V4C23 2.9 22.1 2 21 2ZM21 18H3V4H21V18Z" />
          <path d="M6 18V16.1111C6 14.5222 7.35 13.2222 9 13.2222H15C16.65 13.2222 18 14.5222 18 16.1111V18H6ZM12 11.7778C13.665 11.7778 15 10.4922 15 8.88889C15 7.28556 13.665 6 12 6C10.335 6 9 7.28556 9 8.88889C9 10.4922 10.335 11.7778 12 11.7778Z" />
        </g>
      </svg>
    </SvgIcon>
  );
}

export default WebinarIcon;
